import { useQuery } from '@tanstack/react-query'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery, useApi } from '@fortem-monorepo/react-spa'
import { MonthlyRoll } from '@fortem-monorepo/web-sdk'

import { getMonthlyRollOptions } from '@/react-query/queries/monthly-roll'

const colDefs = createColDefs([
  { field: 'deal_reference', headerName: 'Deal Ref' },
  { field: 'fund_name', headerName: 'Fund' },
  { field: 'shareclass_code', headerName: 'Shareclass Code' },
  { field: 'shareclass_sleeve', headerName: '#Sleeve' },
  { field: 'trade_currency', headerName: 'Trade CCY' },
  {
    field: 'price',
    valueFormatter: numberFormatter({
      minimumFractionDigits: 6,
      maximumFractionDigits: 6,
      delimiter: true,
    }),
  },
  {
    field: 'quantity',
    headerName: 'Trade QTY',
    valueFormatter: numberFormatter({ delimiter: true }),
  },
  { field: 'value_date', headerName: 'Value Date' },
  { field: 'open_datetime_utc', headerName: 'Open Date' },
  { field: 'settlement_date', headerName: 'Settlement Date' },
])

export interface MonthlyRollPendingTradesTableProps {
  params: MonthlyRoll.GetMonthlyRollParams
}

export const MonthlyRollPendingTradesTable: React.FC<MonthlyRollPendingTradesTableProps> = ({
  params,
}) => {
  const api = useApi()
  const query = useQuery({
    ...getMonthlyRollOptions(api, params),
    enabled: false,
  })

  return (
    <Widget exposed className={'h-full'}>
      <WidgetHeaderWithQuery query={query} title="Pending Trades" />
      <WidgetContent loading={query?.isLoading}>
        <CustomAgGrid
          domLayout={'normal'}
          rowData={query.data?.pending_trades}
          columnDefs={colDefs}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}
